import { useMemo } from "react";

import type { ICountryDropdownItem } from "@similarweb/ui-components";

import { swSettings } from "app/common/services/swSettings";
import { CountryFilter } from "app/components/filters-bar/country-filter/CountryFilter";
import { getCountries } from "app/components/filters-bar/utils";
import { allTrackers } from "app/services/track/track";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { useSocialChannelsDataAndParams } from "../../../hooks/social-channels-params";
import type { IFilter } from "../FiltersBar";

const COUNTRY_FILTER_HEIGHT = 60;

const CountryFilterItem = () => {
    const { country } = useSocialChannelsDataAndParams();

    const availableCountries: ICountryDropdownItem[] = useMemo(() => getCountries(true, swSettings.current), []);

    const selectedCountry = useMemo(
        () => availableCountries.find((item) => item.id === country) ?? availableCountries[0],
        [availableCountries, country],
    );

    const handleCountryChange = (selected: ICountryDropdownItem) => {
        allTrackers.dispatchTrackEvent("Drop Down", "click", `Header/Country Filter/${selected.text}`);
        proNavigator.updateQueryParams({ country: selected.id }, { reload: false });
    };

    if (!selectedCountry) {
        return null;
    }

    return (
        <div data-automation="social-ads-country-filter">
            <CountryFilter
                appendTo="body"
                height={COUNTRY_FILTER_HEIGHT}
                availableCountries={availableCountries}
                selectedCountry={selectedCountry.id?.toString()}
                selectedCountryIds={selectedCountry.id ? { [selectedCountry.id]: true } : {}}
                changeCountry={(value) => handleCountryChange(value as unknown as ICountryDropdownItem)}
            />
        </div>
    );
};

export const countryFilterConfigItem: IFilter = {
    id: "country",
    filter: <CountryFilterItem />,
};
